import React, { useMemo } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ReactComponent as AlertIcon } from "go-core/images/svg/alert.svg";
import { FILTER_SEPARATOR, NEW_WAY_TO_ENCODING_FILTER_SIGN } from "go-list/core/components/Filter/services";
import { selectOrganization } from "go-security/services/organizations/selectors";

interface DashboardProductsListHeaderProps {
	stock_id: number;
	stock_name?: string;
	below_zero_count?: number;
}

export const DashboardProductsListHeader = ({
	stock_id,
	stock_name,
	below_zero_count,
}: DashboardProductsListHeaderProps) => {
	const { t } = useTranslation();
	const organization = useSelector(selectOrganization);
	const redirectToStockstateLink = useMemo(() => {
		if (organization.id === undefined) {
			return;
		}

		const filter = btoa(
			unescape(
				encodeURIComponent(
					`${NEW_WAY_TO_ENCODING_FILTER_SIGN}${FILTER_SEPARATOR}stockIds|e=${stock_id}${FILTER_SEPARATOR}available_amount|lt=0`
				)
			)
		);

		return `/${organization.id}/states?f=${filter}`;
	}, [organization.id, stock_id]);

	return (
		<div className="d-flex justify-content-between align-items-center overflow-x-auto">
			<div className="d-flex align-items-center gap-1">
				<AlertIcon />
				{stock_name}
			</div>
			{redirectToStockstateLink && (
				<span>
					<Button variant="add" className="btn-with-link-in-it">
						<Link to={redirectToStockstateLink} target={"_blank"} rel={"noreferrer"}>
							{t("lib:common.action.show_all")} <strong>{below_zero_count}</strong>
						</Link>
					</Button>
				</span>
			)}
		</div>
	);
};
